import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class SessionStorageService {
  constructor() {}

  getItem<T>(key: string, defaultValue: T): T;
  getItem<T>(key: string): T | undefined;
  getItem<T>(key: string, defaultValue?: T): T | undefined {
    if (!window || !window.sessionStorage) return defaultValue;
    const item = window.sessionStorage.getItem(key);
    if (item == null) return defaultValue;

    try {
      return JSON.parse(item);
    } catch {}
    return defaultValue;
  }

  setItem<T>(key: string, value: T): T | undefined {
    if (!window || !window.sessionStorage) return;
    window.sessionStorage.setItem(key, JSON.stringify(value));
    return value;
  }
}
